import React from 'react';
import PropTypes from 'prop-types';
import {
  injectIntl,
  defineMessages,
} from 'react-intl';
import { Box } from '@mui/material';

export const App = ({intl, children}) => {
  const t = defineMessages({
    'app.document.title': {
      id: 'app.document.title',
      defaultMessage: 'My Account',
      description: 'The document title of the application (appears in browser tab)',
    },
  });

  document.title = intl.formatMessage(t['app.document.title']);

  return (
    <Box>
      {children}
    </Box>
  );
};

App.propTypes = {
  children: PropTypes.element.isRequired,
  intl: PropTypes.object,
};

export default injectIntl(App);
